import React, { useEffect, useState } from "react";
import {
  Container,
  Card,
  CardContent,
  Typography,
  Box,
  Grid2,
} from "@mui/material";
import { Search, Home, Bed } from "@mui/icons-material";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../firestore-DB-config/firebase-config"; // Adjust the import based on your setup

interface ServiceCardProps {
  title: string;
  description: string;
  icon: JSX.Element;
}

// Icon mapping function
const getIcon = (iconName: string): JSX.Element => {
  switch (iconName) {
    case "Search":
      return <Search fontSize="large" />;
    case "Home":
      return <Home fontSize="large" />;
    case "Bed":
      return <Bed fontSize="large" />;
    default:
      return <Search fontSize="large" />; // Default icon
  }
};

let ServiceCard = ({ title, description, icon }: ServiceCardProps) => (
  <Card
    elevation={3}
    sx={{
      borderRadius: "15px",
      textAlign: "center",
      width: "100%",
      maxWidth: "300px",
      mx: "auto", // Center the cards horizontally
      transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
      "&:hover": {
        transform: "scale(1.04)",
        boxShadow: 6,
      },
    }}
  >
    <CardContent>
      <Box sx={{ display: "flex", justifyContent: "center", mb: 2, mt: 3 }}>
        {icon}
      </Box>
      <Typography variant="h6" fontWeight="bold">
        {title}
      </Typography>
      <Typography variant="body2" color="textSecondary" mt={2}>
        {description}
      </Typography>
    </CardContent>
  </Card>
);

const ServicesSection = () => {
  const [services, setServices] = useState<Array<any>>([]);

  useEffect(() => {
    // Fetch services from Firestore
    const fetchServices = async () => {
      const servicesCollection = collection(db, "services");
      const servicesSnapshot = await getDocs(servicesCollection);
      const servicesList = servicesSnapshot.docs.map((doc) => doc.data());
      setServices(servicesList);
    };
    fetchServices();
  }, []);

  return (
    <Container sx={{ my: { xs: 6, md: 8 }, px: { xs: 4, md: 4, lg: 0 } }}>
      <Typography
        variant="h5"
        textAlign="left"
        fontWeight={700}
        color="rgba(1, 29, 51, 1)"
        gutterBottom
        sx={{ fontSize: { xs: "24px", sm: "28px" } }}
      >
        OUR SERVICES
      </Typography>
      <Typography
        variant="h4"
        textAlign="left"
        fontWeight={540}
        mb={2}
        color="rgba(1, 29, 51, 1)"
        sx={{ fontSize: { xs: "22px", sm: "32px" } }} // Responsive subheading
      >
        Lorem Ipsum Lorem Ipsum
      </Typography>
      <Typography
        variant="body1"
        textAlign="left"
        color="textSecondary"
        mb={6}
        sx={{ fontSize: { xs: "14px", sm: "16px" } }}
      >
        Donec porttitor euismod dignissim. Nullam a lacinia ipsum, nec dignissim
        purus. Nulla convallis ipsum molestie nibh malesuada, ac malesuada leo
        volutpat.
      </Typography>
      {/* Using Grid2 for layout */}
      <Grid2
        container
        spacing={10} // Reduced spacing for smaller screens
        justifyContent={{ xs: "center", md: "left" }}
      >
        {services.map((service: any, index: number) => (
          <Grid2
            key={index}
            size={{ xs: 12, sm: 6, md: 4 }}
            display="flex"
            flexDirection="column"
            alignItems="center"
          >
            <ServiceCard
              title={service.title}
              description={service.description}
              icon={getIcon(service.icon)} // Use getIcon to map string to icon
            />
          </Grid2>
        ))}
      </Grid2>
    </Container>
  );
};

export default ServicesSection;
